/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018 --> 2020 by AsterionDB Inc.                            *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Row, Col, Label, Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'

import PasswordWidget from './PasswordWidget'

class PasswordModal extends React.Component
{  
  cancelModal()
  {
    this.props.closeModal(false);
  }

  confirmModal()
  {
    this.props.closeModal(true, this.state.password);
  }

  constructor(props)
  {
    super();

    this.state =
    {
      password: '',
      okDisabled: true
    }

    this.cancelModal = this.cancelModal.bind(this);
    this.confirmModal = this.confirmModal.bind(this);
    this.setPassword = this.setPassword.bind(this);
  }

  render()
  {
    return(
      <Modal isOpen={this.props.modalIsOpen} toggle={this.cancelModal} autoFocus={false} >
        <ModalHeader toggle={this.cancelModal}>{this.props.modalHeader}</ModalHeader>
        <ModalBody>
          <Row>
            <Col>{this.props.modalBody}</Col>
          </Row>
          <Row style={{paddingTop: "10px"}}>
            <Label for="password" sm='2'>Password</Label>
            <Col sm="8" >
              <PasswordWidget disabled={false} onChange={this.setPassword} buttonDisabled={false}
                placeholder='Enter your password' value={this.state.password} id="password"/>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" disabled={this.state.okDisabled} onClick={this.confirmModal}>OK</Button>
          <Button color="secondary" onClick={this.cancelModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }

  setPassword(value)
  {
    this.setState({password: value, okDisabled: '' !== value ? false : true});
  }
}

export default PasswordModal